import { fetchData } from "./fetchData";

export const getPlayerByID = async (playerID) => {
  try {
    const route = `/players/${playerID}`;

    const options = {
      method: "GET",
    };

    let response = fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getAllPlayers = async (query) => {
  try {
    const route = `/players${query}`;

    const options = {
      method: "GET",
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const searchPlayers = async (query) => {
  try {
    const route = `/players/options?search=${query}`;

    const options = {
      method: "GET",
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};



export const getTopFighters = async (limit = 5) => {
  try {
    const route = `/players/top-fighters?limit=${limit}`;
    const options = { method: "GET" };
    let response = await fetchData(route, options);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const createPlayer = async (formData) => {
  try {
    const route = `/players`;

    const options = {
      method: "POST",
      Headers: {
        "Content-Type": "application/json",
      },
      body: formData,
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const updatePlayer = async (id, formData) => {
  try {
    const route = `/players/${id}`;

    const options = {
      method: "PUT",
      body: formData,
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};
